import { Box, Heading, Stack, Text } from "@biblioteksentralen/react";
import { ResolvedEventSummary } from "@libry-content/common";
import { ResolvedService } from "@libry-content/common/src/services/groq/resolveService";
import { useTranslation } from "../../utils/hooks/useTranslation";
import { DefaultContainer } from "../ContentContainer";
import { EventsList } from "../arrangement/EventsList";
import BlockContent from "../blockContent/BlockContent";
import { Edit } from "../editInSanity/EditInSanity";
import ContactCard from "../employees/ContactCard";
import { SanityImageWithResponsiveSize } from "../images/SanityImageWithResponsiveSize";

interface Props {
  service?: ResolvedService;
  relatedEvents?: ResolvedEventSummary[];
}

const ServiceView = ({ service, relatedEvents }: Props) => {
  const { t, ts } = useTranslation();

  if (!service) return null;

  return (
    <DefaultContainer>
      <Stack direction="column" spacing="2rem">
        <Stack direction="column">
          <Text fontWeight="600" fontSize=".8rem">
            {ts(service.serviceType?.label)}
          </Text>
          <Heading as="h1">{ts(service.title)}</Heading>
          <Edit doc={service} />
          <Text fontSize="lg" maxWidth="30em">
            {ts(service.teaser)}
          </Text>
        </Stack>

        {service.image?.asset && (
          <Box paddingBottom="2rem">
            <SanityImageWithResponsiveSize
              image={service.image}
              aspectRatio={1.95}
              resolution={{ base: 540, sm: 1080, lg: 2160 }}
            />
          </Box>
        )}

        <BlockContent blocks={ts(service.body)} />

        {service.contact && (
          <Box width="30rem" maxWidth="100%" margin="auto" paddingY="1rem">
            <ContactCard employeeOrLibrary={service.contact} />
          </Box>
        )}

        {relatedEvents && relatedEvents.length > 0 && (
          <Stack width="30rem" maxWidth="100%" margin="auto">
            <Heading as="h2" size="lg">
              {t("Relaterte arrangementer")}
            </Heading>
            <EventsList events={relatedEvents} />
          </Stack>
        )}
      </Stack>
    </DefaultContainer>
  );
};

export default ServiceView;
